export default __webpack_public_path__ + "static/Bodie-fc4351f03498d8b788f76912c597735e.png";